import React from 'react'
import ItemSelectableSimple from '../../components/ItemSelectable/ItemSelectableSimple';
import { useNavigate, useParams } from 'react-router-dom';
import { getReportsTypes } from './ReportsTypes';
import Permanence from '../../containers/Reports/Permanence/Permanence';
import { havePermission } from '../../helpers/helpers';
import { EntryAndDeparture } from '../EntryAndDeparture/EntryAndDeparture';
import PrivateRoute from '../PrivateRoute/PrivateRoute';

export const Reports = () => {
    const navigate = useNavigate();

    const { reportType } = useParams();

    const reportsTypes = {
        entryAndDeparture:
            <PrivateRoute
                redirectTo='/reports'
                permissions={[6]}
            >
                <EntryAndDeparture />
            </PrivateRoute>,
        permanence:
            <PrivateRoute
                redirectTo='/reports'
                permissions={[5]}
            >
                <Permanence />
            </PrivateRoute>,
    }

    const navigateToReport = (redirection) => {
        navigate(redirection);
    }

    if (!reportType) {
        return (
            <div className="col-xl-4 col-lg-7 col-sm-9 mt-5 mx-auto">
                <div className="ps-4 pe-4">
                    {
                        getReportsTypes().types.map((type, i) =>
                            havePermission(type.haveAccess) && (
                                <div key={i} className='mb-2'>
                                    <ItemSelectableSimple onClick={() => navigateToReport(type.redirection)}>
                                        <div>
                                            <p className='m-0 param-section-title'>{type.title}</p>
                                            <p className='m-0 param-section-subtitle'>{type.subtitle}</p>
                                        </div>
                                    </ItemSelectableSimple>
                                </div>
                            )
                        )
                    }
                </div>
            </div>
        );
    }

    if (reportsTypes[reportType]) {
        return reportsTypes[reportType]
    }

}
